import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import { connectHits } from 'react-instantsearch-dom';

const Hits = ({ hits, hitComponent, className }) => {
  return (
    <Grid className={className} container spacing={1}>
      {hits.map(hit => (
        <Grid key={hit.objectID} item xs={12}>
          {hitComponent ? hitComponent({ hit }) : <Paper>{hit.name}</Paper>}
        </Grid>
      ))}
    </Grid>
  );
};

export default connectHits(Hits);